import React, { useEffect, useState } from 'react';
import { getStations, getStation, createStation, updateStation, getEquipeStation, getUsers, affecterUser, retirerAffectation, getObjectifs, setObjectif } from '../services/api';
import { FaEye, FaPen, FaUsers, FaBullseye } from 'react-icons/fa';

const TYPES = ['urbaine', 'rurale', 'autoroute', 'aeroport'];
const REGIONS = ['Dakar', 'Thies', 'Saint-Louis', 'Kaolack', 'Ziguinchor', 'Tambacounda', 'Kolda', 'Matam', 'Fatick', 'Louga', 'Diourbel', 'Kaffrine', 'Kedougou', 'Sedhiou'];
const MOIS_LABELS = ['Janvier','Fevrier','Mars','Avril','Mai','Juin','Juillet','Aout','Septembre','Octobre','Novembre','Decembre'];

const Stations: React.FC = () => {
  const [stations, setStations] = useState<any[]>([]);
  const [search, setSearch] = useState('');
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showEquipeModal, setShowEquipeModal] = useState(false);
  const [showObjectifModal, setShowObjectifModal] = useState(false);
  const [editingStation, setEditingStation] = useState<any>(null);
  const [selectedStation, setSelectedStation] = useState<any>(null);
  const [equipe, setEquipe] = useState<any[]>([]);
  const [allUsers, setAllUsers] = useState<any[]>([]);
  const [objectifs, setObjectifsData] = useState<any[]>([]);
  const [form, setForm] = useState<any>({ code: '', nom: '', adresse: '', ville: '', region: 'Dakar', type_station: 'urbaine', telephone: '', capacite_totale: '', gerant_id: '', date_mise_service: '' });
  const [affectForm, setAffectForm] = useState({ user_id: '', role_station: '' });
  const [objForm, setObjForm] = useState({ mois: new Date().getMonth() + 1, annee: new Date().getFullYear(), objectif_ca: '', objectif_volume: '', objectif_marge: '' });
  const [msg, setMsg] = useState('');

  useEffect(() => { loadStations(); }, []);

  const loadStations = async (s?: string) => {
    setLoading(true);
    try {
      const params: any = {};
      if (s) params.search = s;
      const res = await getStations(params);
      setStations(res.data);
    } catch (err) { console.error(err); }
    setLoading(false);
  };

  const fmt = (n: number) => new Intl.NumberFormat('fr-FR').format(n);

  const openCreate = () => {
    setEditingStation(null);
    setForm({ code: '', nom: '', adresse: '', ville: '', region: 'Dakar', type_station: 'urbaine', telephone: '', capacite_totale: '', gerant_id: '', date_mise_service: '' });
    setShowModal(true);
  };

  const openEdit = async (id: number) => {
    try {
      const res = await getStation(id);
      const s = res.data;
      setEditingStation(s);
      setForm({ code: s.code, nom: s.nom, adresse: s.adresse || '', ville: s.ville || '', region: s.region || 'Dakar', type_station: s.type_station, telephone: s.telephone || '', capacite_totale: s.capacite_totale || '', gerant_id: s.gerant_id || '', date_mise_service: s.date_mise_service ? s.date_mise_service.slice(0, 10) : '', statut: s.statut });
      setShowModal(true);
    } catch (err) { console.error(err); }
  };

  const openDetail = async (id: number) => {
    try {
      const res = await getStation(id);
      setSelectedStation(res.data);
      setShowDetailModal(true);
    } catch (err) { console.error(err); }
  };

  const handleSave = async () => {
    try {
      if (editingStation) {
        await updateStation(editingStation.id, form);
        setMsg('Station mise a jour');
      } else {
        await createStation(form);
        setMsg('Station creee');
      }
      setShowModal(false);
      loadStations();
    } catch (err: any) { setMsg(err.response?.data?.error || 'Erreur'); }
  };

  const openEquipe = async (station: any) => {
    setSelectedStation(station);
    try {
      const [eqRes, usRes] = await Promise.all([getEquipeStation(station.id), getUsers()]);
      setEquipe(eqRes.data);
      setAllUsers(usRes.data);
      setAffectForm({ user_id: '', role_station: '' });
      setShowEquipeModal(true);
    } catch (err) { console.error(err); }
  };

  const handleAffecter = async () => {
    if (!affectForm.user_id || !selectedStation) return;
    try {
      await affecterUser(selectedStation.id, affectForm);
      const res = await getEquipeStation(selectedStation.id);
      setEquipe(res.data);
      setAffectForm({ user_id: '', role_station: '' });
    } catch (err) { console.error(err); }
  };

  const handleRetirer = async (userId: number) => {
    if (!selectedStation) return;
    try {
      await retirerAffectation(selectedStation.id, userId);
      const res = await getEquipeStation(selectedStation.id);
      setEquipe(res.data);
    } catch (err) { console.error(err); }
  };

  const openObjectifs = async (station: any) => {
    setSelectedStation(station);
    try {
      const res = await getObjectifs(station.id, { annee: String(new Date().getFullYear()) });
      setObjectifsData(res.data);
      setObjForm({ mois: new Date().getMonth() + 1, annee: new Date().getFullYear(), objectif_ca: '', objectif_volume: '', objectif_marge: '' });
      setShowObjectifModal(true);
    } catch (err) { console.error(err); }
  };

  const handleSetObjectif = async () => {
    if (!selectedStation) return;
    try {
      await setObjectif(selectedStation.id, objForm);
      const res = await getObjectifs(selectedStation.id, { annee: String(objForm.annee) });
      setObjectifsData(res.data);
      setObjForm({ ...objForm, objectif_ca: '', objectif_volume: '', objectif_marge: '' });
    } catch (err) { console.error(err); }
  };

  return (
    <div>
      <div className="page-header">
        <h2>Stations Total Senegal</h2>
        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
          <span className="badge">{stations.length} stations</span>
          <button className="btn btn-primary" onClick={openCreate}>+ Nouvelle station</button>
        </div>
      </div>

      {msg && <div className="alert alert-success">{msg}</div>}

      <form onSubmit={e => { e.preventDefault(); loadStations(search); }} className="search-bar">
        <input type="text" value={search} onChange={e => setSearch(e.target.value)} placeholder="Rechercher une station..." />
        <button type="submit" className="btn btn-primary">Rechercher</button>
      </form>

      {loading ? <div className="loading">Chargement...</div> : (
        <table className="table">
          <thead>
            <tr><th>Code</th><th>Station</th><th>Ville</th><th>Region</th><th>Type</th><th>Gerant</th><th>Capacite</th><th>Statut</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {stations.map((s: any) => (
              <tr key={s.id}>
                <td><code>{s.code}</code></td>
                <td><strong>{s.nom}</strong></td>
                <td>{s.ville}</td>
                <td>{s.region}</td>
                <td><span className="badge badge-info">{s.type_station}</span></td>
                <td>{s.gerant_prenom} {s.gerant_nom}</td>
                <td>{fmt(s.capacite_totale)} L</td>
                <td><span className={`badge badge-${s.statut === 'active' ? 'success' : 'warning'}`}>{s.statut}</span></td>
                <td>
                  <div style={{ display: 'flex', gap: 4 }}>
                    <button className="btn btn-sm btn-secondary" onClick={() => openDetail(s.id)} title="Details"><FaEye /></button>
                    <button className="btn btn-sm btn-primary" onClick={() => openEdit(s.id)} title="Modifier"><FaPen /></button>
                    <button className="btn btn-sm btn-info" onClick={() => openEquipe(s)} title="Equipe"><FaUsers /></button>
                    <button className="btn btn-sm btn-warning" onClick={() => openObjectifs(s)} title="Objectifs"><FaBullseye /></button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* Create/Edit Modal */}
      {showModal && (
        <div className="modal-overlay" onClick={() => setShowModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600 }}>
            <div className="modal-header">
              <h3>{editingStation ? 'Modifier la station' : 'Nouvelle station'}</h3>
              <button className="modal-close" onClick={() => setShowModal(false)}>&times;</button>
            </div>
            <div className="modal-body">
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
                <div className="form-group">
                  <label>Code *</label>
                  <input type="text" value={form.code} onChange={e => setForm({...form, code: e.target.value})} placeholder="STN-XXX" disabled={!!editingStation} />
                </div>
                <div className="form-group">
                  <label>Nom *</label>
                  <input type="text" value={form.nom} onChange={e => setForm({...form, nom: e.target.value})} placeholder="Total Xxx" />
                </div>
                <div className="form-group" style={{ gridColumn: '1/-1' }}>
                  <label>Adresse</label>
                  <input type="text" value={form.adresse} onChange={e => setForm({...form, adresse: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Ville</label>
                  <input type="text" value={form.ville} onChange={e => setForm({...form, ville: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Region</label>
                  <select value={form.region} onChange={e => setForm({...form, region: e.target.value})}>
                    {REGIONS.map(r => <option key={r} value={r}>{r}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Type</label>
                  <select value={form.type_station} onChange={e => setForm({...form, type_station: e.target.value})}>
                    {TYPES.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                </div>
                <div className="form-group">
                  <label>Telephone</label>
                  <input type="text" value={form.telephone} onChange={e => setForm({...form, telephone: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Capacite totale (L)</label>
                  <input type="number" value={form.capacite_totale} onChange={e => setForm({...form, capacite_totale: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Date mise en service</label>
                  <input type="date" value={form.date_mise_service} onChange={e => setForm({...form, date_mise_service: e.target.value})} />
                </div>
                {editingStation && (
                  <div className="form-group">
                    <label>Statut</label>
                    <select value={form.statut} onChange={e => setForm({...form, statut: e.target.value})}>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                      <option value="maintenance">Maintenance</option>
                    </select>
                  </div>
                )}
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setShowModal(false)}>Annuler</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={!form.code || !form.nom}>{editingStation ? 'Mettre a jour' : 'Creer'}</button>
            </div>
          </div>
        </div>
      )}

      {/* Detail Modal */}
      {showDetailModal && selectedStation && (
        <div className="modal-overlay" onClick={() => setShowDetailModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 500 }}>
            <div className="modal-header">
              <h3>{selectedStation.nom}</h3>
              <button className="modal-close" onClick={() => setShowDetailModal(false)}>&times;</button>
            </div>
            <div className="modal-body" style={{ lineHeight: 2 }}>
              <div><strong>Code:</strong> {selectedStation.code}</div>
              <div><strong>Adresse:</strong> {selectedStation.adresse || '-'}</div>
              <div><strong>Ville:</strong> {selectedStation.ville} - {selectedStation.region}</div>
              <div><strong>Type:</strong> <span className="badge badge-info">{selectedStation.type_station}</span></div>
              <div><strong>Capacite:</strong> {fmt(selectedStation.capacite_totale)} L</div>
              <div><strong>Gerant:</strong> {selectedStation.gerant_prenom} {selectedStation.gerant_nom} {selectedStation.gerant_tel ? `(${selectedStation.gerant_tel})` : ''}</div>
              <div><strong>Statut:</strong> <span className={`badge badge-${selectedStation.statut === 'active' ? 'success' : 'warning'}`}>{selectedStation.statut}</span></div>
              <div><strong>Mise en service:</strong> {selectedStation.date_mise_service ? new Date(selectedStation.date_mise_service).toLocaleDateString('fr-FR') : '-'}</div>
            </div>
            <div className="modal-footer">
              <button className="btn btn-primary" onClick={() => { setShowDetailModal(false); openEdit(selectedStation.id); }}>Modifier</button>
              <button className="btn btn-secondary" onClick={() => setShowDetailModal(false)}>Fermer</button>
            </div>
          </div>
        </div>
      )}

      {/* Equipe Modal */}
      {showEquipeModal && selectedStation && (
        <div className="modal-overlay" onClick={() => setShowEquipeModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 600 }}>
            <div className="modal-header">
              <h3>Equipe - {selectedStation.nom}</h3>
              <button className="modal-close" onClick={() => setShowEquipeModal(false)}>&times;</button>
            </div>
            <div className="modal-body">
              <table className="table">
                <thead><tr><th>Nom</th><th>Role</th><th>Poste</th><th>Action</th></tr></thead>
                <tbody>
                  {equipe.map((m: any) => (
                    <tr key={m.id}>
                      <td>{m.prenom} {m.nom}</td>
                      <td><span className="badge badge-info">{m.role}</span></td>
                      <td>{m.role_station || '-'}</td>
                      <td><button className="btn btn-sm btn-danger" onClick={() => handleRetirer(m.id)}>Retirer</button></td>
                    </tr>
                  ))}
                  {equipe.length === 0 && <tr><td colSpan={4} style={{ textAlign: 'center' }}>Aucun membre</td></tr>}
                </tbody>
              </table>
              <div style={{ marginTop: 16, padding: 12, background: '#f8f9fa', borderRadius: 6 }}>
                <strong>Affecter un utilisateur</strong>
                <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                  <select value={affectForm.user_id} onChange={e => setAffectForm({...affectForm, user_id: e.target.value})} style={{ flex: 2 }}>
                    <option value="">-- Choisir --</option>
                    {allUsers.filter((u: any) => !equipe.find((e: any) => e.id === u.id)).map((u: any) => (
                      <option key={u.id} value={u.id}>{u.prenom} {u.nom} ({u.role})</option>
                    ))}
                  </select>
                  <input type="text" value={affectForm.role_station} onChange={e => setAffectForm({...affectForm, role_station: e.target.value})} placeholder="Poste" style={{ flex: 1 }} />
                  <button className="btn btn-primary" onClick={handleAffecter} disabled={!affectForm.user_id}>Affecter</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Objectifs Modal */}
      {showObjectifModal && selectedStation && (
        <div className="modal-overlay" onClick={() => setShowObjectifModal(false)}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 650 }}>
            <div className="modal-header">
              <h3>Objectifs - {selectedStation.nom}</h3>
              <button className="modal-close" onClick={() => setShowObjectifModal(false)}>&times;</button>
            </div>
            <div className="modal-body">
              <table className="table">
                <thead><tr><th>Mois</th><th style={{ textAlign: 'right' }}>Objectif CA</th><th style={{ textAlign: 'right' }}>Objectif Volume</th><th style={{ textAlign: 'right' }}>Objectif Marge</th></tr></thead>
                <tbody>
                  {objectifs.map((o: any) => (
                    <tr key={`${o.annee}-${o.mois}`}>
                      <td>{MOIS_LABELS[o.mois - 1]} {o.annee}</td>
                      <td style={{ textAlign: 'right' }}>{fmt(Number(o.objectif_ca))} FCFA</td>
                      <td style={{ textAlign: 'right' }}>{fmt(Number(o.objectif_volume))} L</td>
                      <td style={{ textAlign: 'right' }}>{fmt(Number(o.objectif_marge))} FCFA</td>
                    </tr>
                  ))}
                  {objectifs.length === 0 && <tr><td colSpan={4} style={{ textAlign: 'center' }}>Aucun objectif defini</td></tr>}
                </tbody>
              </table>
              <div style={{ marginTop: 16, padding: 12, background: '#f8f9fa', borderRadius: 6 }}>
                <strong>Definir un objectif</strong>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr 1fr auto', gap: 8, marginTop: 8, alignItems: 'end' }}>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label style={{ fontSize: 11 }}>Mois</label>
                    <select value={objForm.mois} onChange={e => setObjForm({...objForm, mois: Number(e.target.value)})}>
                      {MOIS_LABELS.map((m, i) => <option key={i} value={i + 1}>{m}</option>)}
                    </select>
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label style={{ fontSize: 11 }}>CA</label>
                    <input type="number" value={objForm.objectif_ca} onChange={e => setObjForm({...objForm, objectif_ca: e.target.value})} placeholder="0" />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label style={{ fontSize: 11 }}>Volume</label>
                    <input type="number" value={objForm.objectif_volume} onChange={e => setObjForm({...objForm, objectif_volume: e.target.value})} placeholder="0" />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label style={{ fontSize: 11 }}>Marge</label>
                    <input type="number" value={objForm.objectif_marge} onChange={e => setObjForm({...objForm, objectif_marge: e.target.value})} placeholder="0" />
                  </div>
                  <div className="form-group" style={{ margin: 0 }}>
                    <label style={{ fontSize: 11 }}>Annee</label>
                    <input type="number" value={objForm.annee} onChange={e => setObjForm({...objForm, annee: Number(e.target.value)})} />
                  </div>
                  <button className="btn btn-primary" onClick={handleSetObjectif}>OK</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Stations;
